// 実行時のURLで環境判定してGTM IDを設定
const getGtmIdByHost = (): string => {
  const hostname = window.location.hostname

  // production環境: tech.crowdworks.jp
  if (hostname === 'tech.crowdworks.jp') {
    return 'GTM-P7TP5BZW'
  }

  // staging環境: staging.tech.crowdworks.jp
  if (hostname === 'staging.tech.crowdworks.jp') {
    return 'GTM-NMC59RJG'
  }

  // development/ローカル環境: 環境変数から取得
  return process.env.GOOGLE_TAG_MANAGER_ID || ''
}

export const gtmId = getGtmIdByHost()
